import { Component, ElementRef, inject, ViewChild, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SafePipe } from "../../pipe/safe.pipe";

@Component({
  selector: 'app-modal-vizualizador',
  standalone: true,
  imports: [
    MatIcon,
    SafePipe
],
  templateUrl: './modal-vizualizador.component.html',
  styleUrl: './modal-vizualizador.component.css'
})
export class ModalVizualizadorComponent implements OnInit {

  url = "";
  extensao = "";
  maxWidth = "";
  maxHeight = "";
  isDelete = false;
  ignoreMiliseconds = false;
  @ViewChild('meuIframe', { static: true }) meuIframe!: ElementRef;

  public dialog = inject<MatDialogRef<ModalVizualizadorComponent>>(MatDialogRef);
  private readonly sanitizer = inject(DomSanitizer);
  public data = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.ignoreMiliseconds = this.data.ignoreMiliseconds || false;
    if(this.ignoreMiliseconds){
      this.url = this.data.url
    }else{
      this.url = this.data.url + `?v=${new Date().getTime()}`;
    }
    this.extensao = this.data.extensao;
    this.maxWidth = this.data.maxWidth;
    this.maxHeight = this.data.maxHeight;
    this.isDelete = this.data.isDelete;
  }

  deletar(){
    this.dialog.close(true);
  }

  getSafeUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }


}
